import fbx_file_hand from '@/assets/3d/models/hand.fbx?url';
import * as THREE from 'three';
import { ConstantsOpenPose } from '../constants_open_pose';
import { EOpenPoseBodyPartMask } from '../enums/e_open_pose_body_part_mask';
import { find_object_item } from '../open_pose_body/open_pose_body_utils';
import { fbx_file_loader } from './fbx_file_loader';

export async function load_hand_from_file() {
  const out = await fbx_file_loader(fbx_file_hand);

  const mesh = find_object_item<THREE.SkinnedMesh>(out, ConstantsOpenPose.MODEL_INFO_HAND.mesh_name)!;
  mesh.material = new THREE.MeshPhongMaterial();

  for (const object of mesh.skeleton.bones) {
    const point = new THREE.Mesh(
      new THREE.SphereGeometry(0.2),
      new THREE.MeshBasicMaterial({
        color: ConstantsOpenPose.HAND_COLOR,
        depthTest: false,
        transparent: true,
      }),
    );
    point.name = ConstantsOpenPose.INTERSECT_TARGET_POINT_NAME;

    object.add(point);
  }

  const geometry = new THREE.CylinderGeometry(1, 1, 0.4, 32);
  const material = new THREE.MeshBasicMaterial({ color: ConstantsOpenPose.HAND_MASK_COLOR });

  const mask = new THREE.Mesh(geometry, material);

  mask.name = EOpenPoseBodyPartMask.HAND;
  mask.visible = false;
  mask.rotateZ(Math.PI / 2);

  mesh.skeleton.bones[0].add(mask);

  ConstantsOpenPose.OPEN_POSE_PART_FROM_FILE_HAND = out;
}
